import { render, staticRenderFns } from "./events-upcoming.vue?vue&type=template&id=f14c4f74&scoped=true&"
import script from "./events-upcoming.vue?vue&type=script&lang=js&"
export * from "./events-upcoming.vue?vue&type=script&lang=js&"
import style0 from "./events-upcoming.vue?vue&type=style&index=0&id=f14c4f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c4f74",
  null
  
)

/* custom blocks */
import block0 from "./events-upcoming.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports